import React, { useCallback, useMemo, useState } from "react";
import { graphql, navigate, useStaticQuery } from "gatsby";
import slugify from "@sindresorhus/slugify";
import sortPosition from "../utility/sort-position";

const ModuleNewsletter = ({ module }) => {
  const [email, setEmail] = useState("");
  const onChange = useCallback((e) => setEmail(e.target.value), []);
  const link = module?.link || "/newsletter";
  const submit = () => {
    if (!email) return; //TODO validazione
    navigate(`${link}?email=${encodeURIComponent(email)}`);
  };

  const { labelManagerLabels } = useStaticQuery(graphql`
    {
      labelManagerLabels: labelManagerLabels {
        formEmail
      }
    }
  `);

  return (
    <>
      {module?.anchorDesktop && (
        <span id={slugify(module.anchorDesktop)} className="tabs__scroll-anchor" />
      )}
      <section className="section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="newsletter d-flex flex-column flex-lg-row justify-content-center align-items-center">
                <div className="newsletter__label heading-sm-semibold">{module.moduleTitle}</div>
                <div className="newsletter__input">
                  <label className="mb-0">
                    <span className="sr-only">{labelManagerLabels.formEmail}</span>
                    <input
                      type="email"
                      value={email}
                      onChange={onChange}
                      placeholder={module.placeholder || ""}
                    />
                  </label>
                  <button
                    className="newsletter__submit"
                    aria-label="Submit"
                    onClick={submit}
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const Newsletter = ({ data }) => {
  const modules = useMemo(
    () =>
      data.moduleTitleFieldSet.length
        ? data.moduleTitleFieldSet.filter((module) => module.moduleTitle).sort(sortPosition)
        : data.moduleTitleFieldSet,
    [data.moduleTitleFieldSet]
  );
  return (
    <>
      {modules.map((module, i) => (
        <ModuleNewsletter module={module} key={i} />
      ))}
    </>
  );
};

export default Newsletter;
export const fragment = graphql`
  fragment NewsletterFragment on LiferayNewsletter {
    id
    liferayFields {
      siteId
      articleId
    }
    moduleTitleFieldSet {
      moduleTitle
      anchorDesktop
      anchorMobile
      position
      placeholder
      link
    }
  }
`;
